import { SharedComponentsModule } from '@1bill-app/components/shared-components.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AddEditManualAccountPageRoutingModule } from './add-edit-manual-account-routing.module';
import { AddEditManualAccountPage } from './add-edit-manual-account.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AddEditManualAccountPageRoutingModule,
    SharedComponentsModule,
    ReactiveFormsModule,
  ],
  declarations: [AddEditManualAccountPage]
})
export class AddManualAccountPageModule { }
